module.exports = __webpack_public_path__ + "media/components/magazinespage/static/rectangle2-a0aebbc2fe3a90c876f8121d6325590b.svg";